'use strict';

exports.__esModule = true;
exports.default = exports.Trigger = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: white;\n  border: 1px solid rgba(8, 19, 31, 0.5);\n  border-radius: 4px;\n  color: black;\n  margin-top: 10px;\n  padding: 1em;\n  position: absolute;\n  text-align: left;\n'], ['\n  background-color: white;\n  border: 1px solid rgba(8, 19, 31, 0.5);\n  border-radius: 4px;\n  color: black;\n  margin-top: 10px;\n  padding: 1em;\n  position: absolute;\n  text-align: left;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  width: 100%;\n  margin-top: 0.5em;\n  align-items: center;\n'], ['\n  display: flex;\n  width: 100%;\n  margin-top: 0.5em;\n  align-items: center;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  background: ', ';\n  border-radius: 4px;\n  padding: 1px;\n  margin-right: 0.25em;\n  width: 100%;\n'], ['\n  background: ', ';\n  border-radius: 4px;\n  padding: 1px;\n  margin-right: 0.25em;\n  width: 100%;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  background-color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: inherit;\n  flex: 1;\n  padding: 0.5em;\n  width: 100%;\n\n  @media (max-width: 600px) {\n    padding: 0.375em 0.5em;\n  }\n'], ['\n  background-color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: inherit;\n  flex: 1;\n  padding: 0.5em;\n  width: 100%;\n\n  @media (max-width: 600px) {\n    padding: 0.375em 0.5em;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  background: ', ';\n  border-radius: 4px;\n  padding: 1px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  background: ', ';\n  border-radius: 4px;\n  padding: 1px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n  border: none;\n  background-color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 34px;\n  &:focus, &:hover {\n    background: ', ';\n    outline: none;\n    & path {\n      fill: white;\n    }\n  }\n  ', '\n'], ['\n  border: none;\n  background-color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 34px;\n  &:focus, &:hover {\n    background: ', ';\n    outline: none;\n    & path {\n      fill: white;\n    }\n  }\n  ', '\n']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n    background: ', ';\n    & path {\n      fill: white;\n    }\n  '], ['\n    background: ', ';\n    & path {\n      fill: white;\n    }\n  ']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: -9999em;\n  left: -9999em;\n'], ['\n  position: absolute;\n  top: -9999em;\n  left: -9999em;\n']),
    _templateObject9 = _taggedTemplateLiteralLoose(['\n'], ['\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactCopyToClipboard = require('react-copy-to-clipboard');

var _reactSvg = require('react-svg');

var _reactSvg2 = _interopRequireDefault(_reactSvg);

var _clipboard = require('../../images/clipboard.svg');

var _clipboard2 = _interopRequireDefault(_clipboard);

var _checkmark = require('../../images/checkmark.svg');

var _checkmark2 = _interopRequireDefault(_checkmark);

var _sharedStyles = require('../sharedStyles');

var _Trigger2 = require('./Trigger');

var _Trigger3 = _interopRequireDefault(_Trigger2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

exports.Trigger = _Trigger3.default;


var Box = _styledComponents2.default.div(_templateObject);

var ControlsWrap = _styledComponents2.default.div(_templateObject2);

var InputWrap = _styledComponents2.default.div(_templateObject3, _sharedStyles.linearGradient);

var Input = _styledComponents2.default.input(_templateObject4);

var ButtonWrap = _styledComponents2.default.div(_templateObject5, _sharedStyles.linearGradient);

var Button = _styledComponents2.default.button(_templateObject6, _sharedStyles.linearGradient, function (props) {
  return props.copied && (0, _styledComponents.css)(_templateObject7, _sharedStyles.linearGradient);
});

var Text = _styledComponents2.default.span(_templateObject8);

var SVG = (0, _styledComponents2.default)(_reactSvg2.default)(_templateObject9);

var ShareLink = function (_React$Component) {
  _inherits(ShareLink, _React$Component);

  function ShareLink() {
    var _temp, _this, _ret;

    _classCallCheck(this, ShareLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { copied: false }, _this.maybeBlur = function (e) {
      if (!e.relatedTarget || _this.box && !_this.box.contains(e.relatedTarget)) {
        _this.props.onBlur();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ShareLink.prototype.render = function render() {
    var _this2 = this;

    var copied = this.state.copied;

    var _props = this.props,
        _props$title = _props.title,
        title = _props$title === undefined ? _react2.default.createElement(
      'span',
      null,
      'the ',
      _react2.default.createElement(
        'code',
        null,
        'title'
      ),
      ' prop'
    ) : _props$title,
        _props$body = _props.body,
        body = _props$body === undefined ? _react2.default.createElement(
      'span',
      null,
      'the ',
      _react2.default.createElement(
        'code',
        null,
        'body'
      ),
      ' prop'
    ) : _props$body,
        _props$toCopy = _props.toCopy,
        toCopy = _props$toCopy === undefined ? window.location.href : _props$toCopy,
        onBlur = _props.onBlur,
        rest = _objectWithoutProperties(_props, ['title', 'body', 'toCopy', 'onBlur']);

    return _react2.default.createElement(
      Box,
      _extends({
        tabIndex: '0',
        onBlur: this.maybeBlur,
        innerRef: function innerRef(box) {
          return _this2.box = box;
        }
      }, rest),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'strong',
          null,
          title
        )
      ),
      _react2.default.createElement(
        'label',
        { htmlFor: 'url' },
        body
      ),
      _react2.default.createElement(
        ControlsWrap,
        null,
        _react2.default.createElement(
          InputWrap,
          null,
          _react2.default.createElement(Input, {
            readOnly: true,
            id: 'url',
            value: toCopy,
            innerRef: function innerRef(input) {
              if (input) {
                input.focus();input.select();
              }
            }
          })
        ),
        _react2.default.createElement(
          _reactCopyToClipboard.CopyToClipboard,
          {
            text: toCopy,
            onCopy: function onCopy() {
              return _this2.setState({ copied: true });
            }
          },
          _react2.default.createElement(
            ButtonWrap,
            null,
            _react2.default.createElement(
              Button,
              { copied: copied },
              _react2.default.createElement(SVG, { path: copied ? _checkmark2.default : _clipboard2.default }),
              _react2.default.createElement(
                Text,
                null,
                'Copy'
              )
            )
          )
        )
      )
    );
  };

  return ShareLink;
}(_react2.default.Component);

exports.default = ShareLink;


//////////////////
// WEBPACK FOOTER
// ../thicket/packages/thicket-elements/lib/ShareLink/index.js
// module id = 37
// module chunks = 2